import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutation";
import actions from "./action";
import saveStore from "./plugins/saveState.js";

Vue.use(Vuex);

const state = {
  command: "接警人员",
  projectList: [],
  showMaskFlag: false,
  token: "",
  isLoading: false,
  type: true,
  previewImgUrl: "", //图片预览
  imgUrl: "",
  userInfo: {},
  cityList: [], //用户城市列表
  district: null,
  center: [],
  userAuth: [],
  menustatus: true,
  menus: [],
  onlineStatus: 1,
  isAuth: false, //认定书授权
  myAccidentList: [],
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  plugins: [saveStore],
});



// WEBPACK FOOTER //
// ./src/store/index.js